import { ControlsOf, FormGroupType } from '@app/core/utils/formgroup-type';
import { createInstallationLocationAddressForm } from '@shared/forms/installation-location-adderss.formgroup';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CreateMeteringPointCommand } from '@app/api/dmc';
import { createDetailCharacteristicsForm } from '@shared/forms/detail-characteristics.formgroup';
import { createDetailMeterCharacteristicsForm } from '@shared/forms/detail-meter-characteristics.formgroup';


export function createMeteringPointFormGroup(): FormGroupType<CreateMeteringPointCommand> {
  return new FormGroup<ControlsOf<CreateMeteringPointCommand>>({
    identification: new FormControl<string | null>(null),
    validFrom: new FormControl(null, Validators.required),
    parentMeteringPointIdentification: new FormControl<string | null>(null, [Validators.minLength(18), Validators.maxLength(18)]),
    connectionPointId: new FormControl(),
    installationLocationAddress: createInstallationLocationAddressForm(),
    detailCharacteristics: createDetailCharacteristicsForm(),
    detailMeterCharacteristic: createDetailMeterCharacteristicsForm(),

    // @ts-expect-error TS2353: extra property
    connectionPointIdentification: new FormControl<string | null>(null),
    connectionPointAddress: new FormControl(),
    templateId: new FormControl(),
  });
}

